import { LazyIssueApp } from '@jira/issue__lazy-app/src/LazyIssueApp.tsx';
import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { getAIContextPanelResources } from '@jira/router-resources__service-desk-ai-context-panel/src/getAIContextPanelResources.tsx';
import { getResolutionPlanSSRResource } from '@jira/router-resources__service-desk-ai-context-panel/src/ResolutionPlanSSRResource.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getCustomerServiceL1NavigationResources } from '@jira/router-resources__customer-service-l1-navigation/src/getCustomerServiceL1NavigationResources.tsx';
import { embeddedIssuePreloadLayoutBuilder } from '@jira/platform__layouts-issue-preload-layout/src/index.tsx';
import { getIssueViewResources } from '@jira/router-resources__issue-view/src/getIssueViewResources.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { csmAppSidebarEntryPoint } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-csm-app/src/csmAppSidebarEntryPoint.entrypoint.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { composeLayouts } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import {
	getQueuesResources,
	getKnowledgeBaseResources,
	getInsightResources,
	getIssueViewResources as getIssueViewResourcesServiceDesk,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { csmQueuesIssueRoute } from '@jira/router-routes__servicedesk-queues-routes/src/csmQueuesIssueRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { getDraftReplyPillsResource } from '@jira/router-resources__service-desk-draft-reply/src/getDraftReplyPillsResource.tsx';
import { queuesIssueViewEntryPoint } from '@jira/spa-apps__servicedesk-queues-issue-view/src/queuesIssueViewEntryPoint.entrypoint.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const csmQueuesIssuePageEntryPoint = createPageEntryPoint({
	main: queuesIssueViewEntryPoint,
	leftSidebar: {
		sidebar: csmAppSidebarEntryPoint,
		isProjectsExpanded: true,
	},
});

export const csmQueuesIssueRouteEntry: Route = createEntry(csmQueuesIssueRoute, () => ({
	group: 'customer-service',

	layout: composeLayouts(
		serviceProjectLayout,
		embeddedIssuePreloadLayoutBuilder([
			{
				params: [
					{
						key: 'issueKey',
					},
				],
			},
		]),
	),

	navigation: {
		sidebarId: SidebarIdCsmApp,
	},

	resources: [
		...getCustomerServiceL1NavigationResources(),
		...getQueuesResources(),
		...getIssueViewResources(),
		...getKnowledgeBaseResources(),
		...getInsightResources(),
		getConsolidationStateResource(),
		...getAIContextPanelResources(),
		...getResolutionPlanSSRResource(),
		...getDraftReplyPillsResource(),
		...getIssueViewResourcesServiceDesk(),
	],

	afterPaint: [LazyIssueApp],

	entryPoint() {
		return fg('csm_appification_standalone_navigation')
			? csmQueuesIssuePageEntryPoint
			: notFoundPageEntrypoint;
	},

	isHydrateRootEnabled: false,

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
